import React from "react";
import { IOnGoingTrip } from "@types";

interface ShareSectionProps {
  detail?: IOnGoingTrip | null;
  currencyLocation?: string;
  handleShare?: (id: string) => void;
}

export const ShareSection: React.FC<ShareSectionProps> = ({
  detail,
  currencyLocation,
  handleShare,
}) => (
  <div className="padding-y-20 padding-x-15 border-bottom-width-1">
    {currencyLocation && (
      <div className="display-flex align-items-center gap-4">
        <span className="rioglyph rioglyph-map-marker text-size-18 text-color-primary" />
        <span
          className="text-normal text-size-16"
          style={{ whiteSpace: "nowrap" }}
        >
          {currencyLocation}
        </span>
      </div>
    )}

    <div className="display-flex justify-content-end margin-top-10">
      <button
        type="button"
        className="btn btn-default"
        onClick={() => handleShare?.(detail?.tripId as string)}
      >
        Compartilhar link da viagem completa
      </button>
    </div>
  </div>
);